import { useState } from 'react';

const faqs = [
  {
    q: 'Cos\u2019\u00e8 Itaobuy Spreadsheet?',
    a: '<strong>Itaobuy Spreadsheet</strong> \u00e8 uno strumento avanzato per la gestione e l\u2019organizzazione dei dati, progettato per offrire un\u2019esperienza semplice e intuitiva. Combina funzionalit\u00e0 potenti con un\u2019interfaccia accessibile, rendendolo adatto sia ai principianti che agli utenti esperti.',
  },
  {
    q: 'Itaobuy Spreadsheet \u00e8 affidabile?',
    a: 'S\u00ec, <strong>Itaobuy Spreadsheet</strong> \u00e8 uno strumento affidabile utilizzato da migliaia di utenti. Adotta standard di sicurezza elevati e offre un servizio stabile e performante. La piattaforma viene costantemente aggiornata per garantire la massima affidabilit\u00e0.',
  },
  {
    q: 'Come utilizzare Itaobuy Spreadsheet?',
    a: 'Utilizzare <strong>Itaobuy Spreadsheet</strong> \u00e8 molto semplice: crea un account, configura il tuo spazio di lavoro, importa o inserisci i tuoi dati e inizia a gestirli con gli strumenti integrati. Consulta la nostra guida completa per un tutorial dettagliato.',
  },
  {
    q: 'Quali sono i vantaggi di Itaobuy Spreadsheet?',
    a: 'I principali vantaggi includono: interfaccia intuitiva, automazione dei processi ripetitivi, gestione avanzata dei dati, risparmio di tempo significativo, elevata personalizzazione e supporto dedicato. \u00c8 la soluzione ideale per chi cerca efficienza e semplicit\u00e0.',
  },
  {
    q: 'Quanto costa Itaobuy Spreadsheet?',
    a: 'Il prezzo di <strong>Itaobuy Spreadsheet</strong> varia in base al piano scelto. Visita il sito ufficiale per scoprire le opzioni disponibili e trovare il piano pi\u00f9 adatto alle tue esigenze. Sono disponibili diverse fasce di prezzo per soddisfare ogni necessit\u00e0.',
  },
  {
    q: 'Esistono alternative a Itaobuy Spreadsheet?',
    a: 'Esistono diverse alternative sul mercato, ma <strong>Itaobuy Spreadsheet</strong> si distingue per la combinazione unica di facilit\u00e0 d\u2019uso, potenza e flessibilit\u00e0. Rispetto ad altri strumenti, offre un miglior rapporto qualit\u00e0-prezzo e un\u2019esperienza utente superiore.',
  },
];

export default function FAQSection() {
  const [openIdx, setOpenIdx] = useState<number | null>(null);

  const faqSchema = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqs.map((f) => ({
      '@type': 'Question',
      name: f.q,
      acceptedAnswer: {
        '@type': 'Answer',
        text: f.a.replace(/<[^>]*>/g, ''),
      },
    })),
  };

  return (
    <section className="w-full py-16 md:py-24 px-4 md:px-6 bg-background-50">
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(faqSchema) }} />
      <div className="max-w-3xl mx-auto">
        <div className="text-center mb-12 md:mb-16">
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-900 mb-4">
            Domande Frequenti su <strong>Itaobuy Spreadsheet</strong>
          </h2>
          <p className="text-base text-foreground-600">
            Trova le risposte alle domande pi&ugrave; comuni su Itaobuy Spreadsheet.
          </p>
        </div>

        <div className="space-y-3">
          {faqs.map((faq, idx) => (
            <div key={idx} className="bg-background-50 border border-background-200 rounded-xl overflow-hidden transition-all">
              <button
                onClick={() => setOpenIdx(openIdx === idx ? null : idx)}
                className="w-full flex items-center justify-between px-6 py-4 text-left cursor-pointer hover:bg-background-100 transition-colors"
              >
                <span className="text-sm md:text-base font-semibold text-foreground-900 pr-4">{faq.q}</span>
                <div className={`w-6 h-6 flex items-center justify-center rounded-full bg-primary-50 text-primary-500 flex-shrink-0 transition-transform duration-300 ${openIdx === idx ? 'rotate-45' : ''}`}>
                  <i className="ri-add-line text-sm"></i>
                </div>
              </button>
              <div
                className={`overflow-hidden transition-all duration-300 ${
                  openIdx === idx ? 'max-h-96 pb-5' : 'max-h-0'
                }`}
              >
                <div
                  className="px-6 text-sm text-foreground-600 leading-relaxed"
                  dangerouslySetInnerHTML={{ __html: faq.a }}
                />
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}